// src/post-template-variation.js

import { registerBlockVariation } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';

export const registerBlockbiteVariations = () => {
  registerBlockVariation('core/query', {
    name: 'dynamic-carousel-query',
    title: __('Blockbite Dynamic Carousel', 'text-domain'),
    innerBlocks: [
      [
        'core/post-template',
        {
          variation: 'dynamic-carousel-template',
        },
      ],
    ],
    description: __(
      'A custom variation of the query block that includes a dynamic carousel.',
      'blockbite'
    ),
    parent: ['blockbite/dynamic-content-carousel'],
    scope: ['block'],
  });

  registerBlockVariation('core/post-template', {
    name: 'dynamic-carousel-template',
    title: __('Blockbite Dynamic Carousel Template', 'text-domain'),
    description: __(
      'A custom variation of the post-template block.',
      'blockbite'
    ),
  });
};
